import { graphql } from 'gql';

export const bimCreateActKC2OtherCorrectionGql = graphql(`
    mutation bimCreateActKC2OtherCorrection($input: BimActKC2OtherCorrectionCreateInput!) {
        bimCreateActKC2OtherCorrection(input: $input) {
            data {
                authoredBy
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                contractor
                contractorAddress
                createdAt
                date
                finishDate
                hasPlanValues
                id
                number
                startDate
                status
                statusFollowers
                uniqueId
                updatedAt
                updatedBy
                workOrderId
                workOrderObject {
                    canSetGuaranteedVolume
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractId
                    fromWorkOrder
                    hasGuaranteedVolume
                    id
                    isActKC2Object
                    name
                    objectSeasonDistributions {
                        contractSeason {
                            id
                            year
                        }
                        id
                        seasonValue
                    }
                    order
                    parentBasedOrder
                    parentId
                    rationale
                    rootObjectId
                    status
                    workOrderId
                    workOrderObjectId
                }
                workOrderSeason {
                    id
                    workOrderId
                    workOrderSeasonId
                    year
                }
                fullNumber
                correctionDate
                isInactive
                isCorrection
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateActKC2OtherCorrectionGql = graphql(`
    mutation bimUpdateActKC2OtherCorrection($input: BimActKC2OtherCorrectionUpdateInput!) {
        bimUpdateActKC2OtherCorrection(input: $input) {
            data {
                authoredBy
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                contractor
                contractorAddress
                createdAt
                date
                finishDate
                hasPlanValues
                id
                number
                startDate
                status
                statusFollowers
                uniqueId
                updatedAt
                updatedBy
                workOrderId
                workOrderObject {
                    canSetGuaranteedVolume
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractId
                    fromWorkOrder
                    hasGuaranteedVolume
                    id
                    isActKC2Object
                    name
                    objectSeasonDistributions {
                        contractSeason {
                            id
                            year
                        }
                        id
                        seasonValue
                    }
                    order
                    parentBasedOrder
                    parentId
                    rationale
                    rootObjectId
                    status
                    workOrderId
                    workOrderObjectId
                }
                workOrderSeason {
                    id
                    workOrderId
                    workOrderSeasonId
                    year
                }
                fullNumber
                correctionDate
                isInactive
                isCorrection
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
